<template>
	<div class="w-100">
		<h3 class="mb-3" v-once>Dimensi</h3>
		<span v-once>Silahkan memilih minimal satu opsi setiap dimensi yang tersedia di
			bawah</span>
		<div v-show="originalIsPeriodNextClicked">
			<b-skeleton-wrapper :loading="loadingDimensionInput">
				<b-row v-for="val in 2" :key="val" class="mt-2 mx-0" align-v="center">
					<b-col class="p-0">
						<b-skeleton-img no-aspect height="5rem"></b-skeleton-img>
					</b-col>
				</b-row>
				<b-row class="mt-2 mx-0" align-v="center" align-h="end">
					<b-col v-for="idx of 2" :key="idx" class="p-0" cols="1"
						style="display: flex !important; justify-content: center !important">
						<b-skeleton type="button"></b-skeleton>
					</b-col>
				</b-row>
			</b-skeleton-wrapper>
		</div>

		<div class="mt-2" role="tablist" v-show="loadingDimensionInput">
			<b-card v-for="(option_dimension, idx_dimension) in optionsDimension" :key="idx_dimension" no-body
				class="mb-1">
				<b-card-header role="tab" class="p-1">
					<b-button block class="
							td-dimension-accordion-button-header
							td-border-button-sm-transparent
						" v-b-toggle="'tabel-dinamis-dimension-accordion-' + idx_dimension" :style="{
							'background-color':
								buttonHeaderColorList[idx_dimension] + '!important',
							color: 'black !important',
						}" @click="rotateAccordionIconButtonHeader($event, idx_dimension)">
						<b-row class="font-weight-bolder">
							<b-col align="left">
								{{ capitalizeEachWord(option_dimension.name) }}
							</b-col>
							<b-col align="right">
								<b-icon :id="'accordion-dimension-icon-button-header-' + idx_dimension
									" class="tabel-dinamis-accordion-icon-button-header" icon="chevron-double-down"></b-icon>
							</b-col>
						</b-row>
					</b-button>
				</b-card-header>

				<b-collapse :id="'tabel-dinamis-dimension-accordion-' + idx_dimension"
					accordion="tabel-dinamis-dimension-accordion" role="tabpanel">
					<b-card-body>
						<b-row>
							<b-col cols="5">
								<template v-if="option_dimension.role.toLowerCase() === 'region'">
									<span class="font-weight-bolder">Level Penyajian Data Secara Wilayah :
									</span>

									<b-form-radio-group class="mt-2" v-model="selectedRegionLevel" stacked
										name="radio-group-region-level">
										<b-form-radio v-if="
											option_dimension.initialParentLevel.toLowerCase() ===
											regionLevel.nas &&
											(option_dimension.lowestLevel.toLowerCase() ===
												regionLevel.nas ||
												option_dimension.lowestLevel.toLowerCase() ===
												regionLevel.prov ||
												option_dimension.lowestLevel.toLowerCase() ===
												regionLevel.kako ||
												option_dimension.lowestLevel.toLowerCase() ===
												regionLevel.kec ||
												option_dimension.lowestLevel.toLowerCase() ===
												regionLevel.deskel)
										" value="NationalByProvince">
											<span id="tabel-dimensi-region-radio-level-1">Nasional Per Provinsi</span>
										</b-form-radio>

										<b-form-radio v-if="
											(option_dimension.initialParentLevel.toLowerCase() ===
												regionLevel.nas ||
												option_dimension.initialParentLevel.toLowerCase() ===
												regionLevel.prov) &&
											(option_dimension.lowestLevel.toLowerCase() ===
												regionLevel.kako ||
												option_dimension.lowestLevel.toLowerCase() ===
												regionLevel.kec ||
												option_dimension.lowestLevel.toLowerCase() ===
												regionLevel.deskel)
										" value="ProvinceByDistrict">
											<span id="tabel-dimensi-region-radio-level-2">Provinsi Per
												Kabupaten/Kota</span>
										</b-form-radio>

										<b-form-radio v-if="
											(option_dimension.initialParentLevel.toLowerCase() ===
												regionLevel.nas ||
												option_dimension.initialParentLevel.toLowerCase() ===
												regionLevel.prov ||
												option_dimension.initialParentLevel.toLowerCase() ===
												regionLevel.kako) &&
											(option_dimension.lowestLevel.toLowerCase() ===
												regionLevel.kec ||
												option_dimension.lowestLevel.toLowerCase() ===
												regionLevel.deskel)
										" value="DistrictBySubdistrict">
											<span id="tabel-dimensi-region-radio-level-3">Kabupaten/Kota Per
												Kecamatan</span>
										</b-form-radio>

										<b-form-radio v-if="
											(option_dimension.initialParentLevel.toLowerCase() ===
												regionLevel.nas ||
												option_dimension.initialParentLevel.toLowerCase() ===
												regionLevel.prov ||
												option_dimension.initialParentLevel.toLowerCase() ===
												regionLevel.kako ||
												option_dimension.initialParentLevel.toLowerCase() ===
												regionLevel.deskel) &&
											option_dimension.lowestLevel.toLowerCase() ===
											regionLevel.deskel
										" value="SubdistrictByVillage">
											<span id="tabel-dimensi-region-radio-level-4">Kecamatan Per
												Desa/Kelurahan</span>
										</b-form-radio>
									</b-form-radio-group>

									<b-form-group class="mt-3" label="Provinsi :" label-class="font-weight-bolder"
										v-show="isSelectProvince">
										<b-skeleton-wrapper :loading="loadingProvinceInput">
											<b-row class="mt-0 mx-0" align-v="center">
												<b-col class="p-0" cols="7">
													<b-skeleton type="input"></b-skeleton>
												</b-col>
												<b-col class="p-0" cols="4" style="
														display: flex !important;
														justify-content: center !important;
													">
													<b-skeleton type="button"></b-skeleton>
												</b-col>
											</b-row>
										</b-skeleton-wrapper>

										<div v-show="loadingProvinceInput">
											<b-form-select class="
													font-weight-normal
													tabel-dinamis-select-region-level
												" :select-size="1" style="width: 75% !important" v-model="selectedProvince" size="sm" @change="
													optionsRegion = '';
												optionsDistrict = '';
												optionsSubdistrict = '';
												selectedDistrict = null;
												selectedSubdistrict = null;
												isSelectRegion = false;
												isSelectDistrict = false;
												isSelectSubdistrict = false;
												selectedDimension[idx_dimension] = [];
												allDimensionSelected[idx_dimension] = false;
												indeterminateDimension[idx_dimension] = false;
												" :disabled="isLoadingAnOptions">
												<template #first>
													<b-form-select-option :value="null" disabled>-- Silahkan memilih
														salah satu provinsi
														--</b-form-select-option>
												</template>

												<template v-for="(
														option_item_dimension, index
													) in optionsProvince">
													<b-form-select-option v-if="index > 0"
														:key="option_item_dimension.id" :value="option_item_dimension"
														:title="option_item_dimension.id.name">{{
															option_item_dimension.name
														}}</b-form-select-option>
												</template>
											</b-form-select>

											<b-button class="mx-1 td-btn-blue" :disabled="selectedProvince == null || isLoadingAnOptions
												" @click="nextFromProvince()" title="Melanjutkan ke daftar kabupaten/kota">Lanjut <b-icon
													icon="chevron-double-right" /></b-button>
										</div>
									</b-form-group>

									<b-form-group label="Kabupaten/Kota :" label-class="font-weight-bolder"
										v-show="isSelectDistrict">
										<b-skeleton-wrapper :loading="loadingDistrictInput">
											<b-row class="mt-0 mx-0" align-v="center">
												<b-col class="p-0" cols="7">
													<b-skeleton type="input"></b-skeleton>
												</b-col>
												<b-col class="p-0" cols="4" style="
														display: flex !important;
														justify-content: center !important;
													">
													<b-skeleton type="button"></b-skeleton>
												</b-col>
											</b-row>
										</b-skeleton-wrapper>

										<div v-show="loadingDistrictInput">
											<b-form-select class="
													font-weight-normal
													tabel-dinamis-select-region-level
												" :select-size="1" style="width: 75% !important" v-model="selectedDistrict" size="sm" @change="
													optionsRegion = '';
												optionsSubdistrict = '';
												selectedSubdistrict = null;
												isSelectRegion = false;
												isSelectSubdistrict = false;
												selectedDimension[idx_dimension] = [];
												allDimensionSelected[idx_dimension] = false;
												indeterminateDimension[idx_dimension] = false;
												" :disabled="isLoadingAnOptions">
												<template #first>
													<b-form-select-option :value="null" disabled>-- Silahkan memilih
														salah satu kabupaten/kota
														--</b-form-select-option>
												</template>

												<template v-for="(
														option_item_dimension, index
													) in optionsDistrict">
													<b-form-select-option v-if="index > 0"
														:key="option_item_dimension.id" :value="option_item_dimension"
														:title="option_item_dimension.id.name">
														{{ option_item_dimension.name }}
														<template v-if="
															option_item_dimension.code.length === 4 &&
															option_item_dimension.code.substring(2, 3) ===
															'7'
														">
															(Kota)
														</template>
													</b-form-select-option>
												</template>
											</b-form-select>

											<b-button class="mx-1 td-btn-blue" :disabled="selectedDistrict == null || isLoadingAnOptions
												" @click="nextFromDistrict()" title="Melanjutkan ke daftar kecamatan">Lanjut <b-icon
													icon="chevron-double-right" /></b-button>
										</div>
									</b-form-group>

									<b-form-group label="Kecamatan :" label-class="font-weight-bolder"
										v-show="isSelectSubdistrict">
										<b-skeleton-wrapper :loading="loadingSubdistrictInput">
											<b-row class="mt-0 mx-0" align-v="center">
												<b-col class="p-0" cols="7">
													<b-skeleton type="input"></b-skeleton>
												</b-col>
												<b-col class="p-0" cols="4" style="
														display: flex !important;
														justify-content: center !important;
													">
													<b-skeleton type="button"></b-skeleton>
												</b-col>
											</b-row>
										</b-skeleton-wrapper>

										<div v-show="loadingSubdistrictInput">
											<b-form-select class="
													font-weight-normal
													tabel-dinamis-select-region-level
												" :select-size="1" style="width: 75% !important" v-model="selectedSubdistrict" size="sm" @change="
													optionsRegion = '';
												isSelectRegion = false;
												selectedDimension[idx_dimension] = [];
												allDimensionSelected[idx_dimension] = false;
												indeterminateDimension[idx_dimension] = false;
												" :disabled="isLoadingAnOptions">
												<template #first>
													<b-form-select-option :value="null" disabled>-- Silahkan memilih
														salah satu kecamatan
														--</b-form-select-option>
												</template>

												<template v-for="(
														option_item_dimension, index
													) in optionsSubdistrict">
													<b-form-select-option v-if="index > 0"
														:key="option_item_dimension.id" :value="option_item_dimension"
														:title="option_item_dimension.id.name">{{
															option_item_dimension.name
														}}</b-form-select-option>
												</template>
											</b-form-select>

											<b-button class="mx-1 td-btn-blue" :disabled="selectedSubdistrict == null || isLoadingAnOptions
												" @click="nextFromSubdistrict()" title="Melanjutkan ke daftar desa/kelurahan">Lanjut <b-icon
													icon="chevron-double-right" /></b-button>
										</div>
									</b-form-group>

									<b-form-group class="mt-3" v-show="isSelectRegion">
										<b-skeleton-wrapper :loading="loadingRegionInput">
											<b-row class="mt-2 mx-0" align-v="center">
												<b-col class="p-0" cols="3">
													<b-skeleton type="input"></b-skeleton>
												</b-col>
											</b-row>
											<b-row v-for="val in 2" :key="val" class="mt-2 mx-0" align-v="center">
												<b-col class="p-0 ml-4" cols="3">
													<b-skeleton type="input"></b-skeleton>
												</b-col>
											</b-row>
											<b-row class="mt-2 mx-0" align-v="center">
												<b-col class="p-0 ml-4" cols="1"> </b-col>
												<b-col class="p-0 ml-1" cols="1" v-for="val in 2" :key="val" style="
														display: flex !important;
														justify-content: center !important;
													">
													<b-skeleton type="button"></b-skeleton>
												</b-col>
											</b-row>
										</b-skeleton-wrapper>

										<div class="mb-2 font-weight-bolder" v-show="loadingRegionInput">
											{{ regionName }}
										</div>

										<b-card body-class="p-3" v-show="loadingRegionInput">
											<b-card-text>
												<b-form-checkbox class="td-checkbox"
													:indeterminate="indeterminateDimension[idx_dimension]"
													v-model="allDimensionSelected[idx_dimension]"
													@change="toggleAllDimension($event, idx_dimension)"
													:disabled="isLoadingAnOptions">{{
														allDimensionSelected[idx_dimension]
															? "Unselect All"
															: "Select All"
													}}
												</b-form-checkbox>

												<b-form-checkbox-group v-model="selectedDimension[idx_dimension]"
													stacked class="ml-4" @change="
														setIsDimensionSaveClicked(idx_dimension, false)
														" :disabled="isLoadingAnOptions" style="
														overflow-y: auto !important;
														max-height: 20rem !important;
													">
													<b-form-checkbox class="td-checkbox"
														v-for="option_item_dimension in optionsRegion"
														:value="option_item_dimension" :key="option_item_dimension.id">
														{{ option_item_dimension.name }}
														<template v-if="
															option_item_dimension.code.length === 4 &&
															option_item_dimension.code.substring(2, 3) ===
															'7'
														">(Kota)
														</template>
													</b-form-checkbox>
												</b-form-checkbox-group>

												<b-row>
													<b-col class="mt-2 font-weight-bolder"
														style="font-size: 0.8rem !important">
														Jumlah
														{{ regionName }}
														Terpilih:
														{{ selectedDimension[idx_dimension].length }}
													</b-col>
												</b-row>

												<b-row class="mt-2">
													<b-col align="right">
														<b-button class="mx-1 td-btn-blue" :disabled="selectedDimension[idx_dimension].length < 1
															" @click="
																setIsDimensionSaveClicked(idx_dimension, true)
																">Simpan <b-icon icon="box-arrow-in-right" /></b-button>
													</b-col>
												</b-row>
											</b-card-text>
										</b-card>
									</b-form-group>

									<!-- tooltip radio region level -->
									<b-tooltip target="tabel-dimensi-region-radio-level-1" triggers="hover"
										placement="right">
										Akan menampilkan data provinsi
									</b-tooltip>

									<b-tooltip target="tabel-dimensi-region-radio-level-2" triggers="hover"
										placement="right">
										Akan menampilkan data kabupaten/kota pada suatu provinsi
									</b-tooltip>

									<b-tooltip target="tabel-dimensi-region-radio-level-3" triggers="hover"
										placement="right">
										Akan menampilkan data kecamatan pada suatu kabupaten/kota
									</b-tooltip>
									<b-tooltip target="tabel-dimensi-region-radio-level-4" triggers="hover"
										placement="right">
										Akan menampilkan data desa/kelurahan pada suatu kecamatan
									</b-tooltip>
								</template>

								<template v-else>
									<b-form-checkbox class="td-checkbox"
										:indeterminate="indeterminateDimension[idx_dimension]"
										v-model="allDimensionSelected[idx_dimension]"
										@change="toggleAllDimension($event, idx_dimension)"
										:disabled="isLoadingAnOptions">
										{{
											allDimensionSelected[idx_dimension]
												? "Unselect All"
												: "Select All"
										}}
									</b-form-checkbox>

									<b-form-checkbox-group v-model="selectedDimension[idx_dimension]" stacked
										class="ml-4" @change="setIsDimensionSaveClicked(idx_dimension, false)"
										:disabled="isLoadingAnOptions" style="
											overflow-y: auto !important;
											max-height: 20rem !important;
										">
										<b-form-checkbox class="td-checkbox"
											v-for="option_item_dimension in option_dimension.itemsDimension"
											:value="option_item_dimension" :key="option_item_dimension.id">
											{{ option_item_dimension.name }}
										</b-form-checkbox>
									</b-form-checkbox-group>

									<b-row>
										<b-col class="mt-2 font-weight-bolder" style="font-size: 0.8rem !important">
											Jumlah
											{{ capitalizeEachWord(option_dimension.name) }} Terpilih:
											{{ selectedDimension[idx_dimension].length }}
										</b-col>
									</b-row>

									<b-row class="mt-2">
										<b-col align="right">
											<b-button class="mx-1 td-btn-blue"
												:disabled="selectedDimension[idx_dimension].length < 1"
												@click="setIsDimensionSaveClicked(idx_dimension, true)"
												title="Simpan opsi item dimensi">Simpan <b-icon
													icon="box-arrow-in-right" /></b-button>
										</b-col>
									</b-row>
								</template>
							</b-col>
							<b-col cols="7">
								<b-row>
									<b-col align="right">
										<b-button class="ml-1 td-btn-teal float-right"
											@click="reverseIsDimensionMetadata(idx_dimension)">
											<b-icon icon="tags" />
											<template v-if="!isDimensionMetadata[idx_dimension]"> Lihat</template>
											<template v-else> Tutup </template> Metadata</b-button>
									</b-col>
								</b-row>

								<transition name="td-slide">
									<div class="mt-4" v-show="isDimensionMetadata[idx_dimension]">
										<b-row>
											<b-col>
												<h6 class="m-0">Metadata Dimensi</h6>
											</b-col>
										</b-row>

										<b-row class="mt-2">
											<b-col>
												<b-icon icon="bookmarks-fill" />
												<span class="font-weight-bold ml-1">Dimensi</span>
											</b-col>
										</b-row>

										<b-row>
											<b-col class="ml-4" cols="10">
												<span class="font-weight-bolder" style="font-size: 0.75rem">{{
													capitalizeEachWord(option_dimension.name) }}
												</span>
											</b-col>
										</b-row>

										<b-row class="mt-2">
											<b-col>
												<b-icon icon="info-circle" />
												<span class="font-weight-bold ml-1">Versi Klasifikasi</span>
											</b-col>
										</b-row>

										<b-row>
											<b-col class="ml-4" cols="10">
												<span style="font-size: 0.75rem">{{
													option_dimension.classificationVersion }}
												</span>
											</b-col>
										</b-row>

										<b-row class="mt-2">
											<b-col>
												<b-icon icon="box" />
												<span class="font-weight-bold ml-1">Domain Nilai</span>
											</b-col>
										</b-row>

										<b-row>
											<b-col class="ml-4" cols="10">
												<span style="font-size: 0.75rem">{{
													changeNullIntoStrip(
														option_dimension.dimensionValueDomainName
													)
												}}
												</span>
											</b-col>
										</b-row>

										<b-row class="mt-2">
											<b-col>
												<b-icon icon="caret-down" />
												<span class="font-weight-bold ml-1">Level Item Teratas</span>
											</b-col>
										</b-row>

										<b-row>
											<b-col class="ml-4" cols="10">
												<span style="font-size: 0.75rem">{{
													changeNullIntoStrip(
														option_dimension.initialParentLevel
													)
												}}
												</span>
											</b-col>
										</b-row>

										<b-row class="mt-2">
											<b-col>
												<b-icon icon="caret-up" />
												<span class="font-weight-bold ml-1">Level Item Terbawah</span>
											</b-col>
										</b-row>

										<b-row>
											<b-col class="ml-4" cols="10">
												<span style="font-size: 0.75rem">{{
													changeNullIntoStrip(option_dimension.lowestLevel)
												}}
												</span>
											</b-col>
										</b-row>

										<b-row class="mt-2">
											<b-col>
												<b-icon icon="list-task" />
												<span class="font-weight-bold ml-1">Daftar Item Dimensi</span>
											</b-col>
										</b-row>

										<b-row>
											<b-col class="ml-4" cols="10">
												<b-table-simple class="mt-2" hover responsive small striped>
													<b-thead class="td-bg-blue text-light">
														<b-tr>
															<b-th> Kode </b-th>
															<b-th> Nama </b-th>
															<b-th> Deskripsi </b-th>
														</b-tr>
													</b-thead>
													<b-tbody>
														<template v-if="
															option_dimension.role.toLowerCase() ===
															'region' && optionsRegionUnited !== ''
														">
															<b-tr v-for="(
																	itemDimension, idx_itemDimension
																) of optionsRegionUnited" :key="idx_itemDimension">
																<b-td align="center">
																	{{ itemDimension.code }}
																</b-td>
																<b-td>
																	{{ itemDimension.name }}
																	<template v-if="
																		itemDimension.code.length === 4 &&
																		itemDimension.code.substring(2, 3) === '7'
																	">
																		(Kota)
																	</template>
																</b-td>
																<b-td>
																	{{
																		changeNullIntoStrip(
																			itemDimension.description
																		)
																	}}
																</b-td>
															</b-tr>
														</template>

														<template v-else-if="
															option_dimension.role.toLowerCase() ===
															'dimension'
														">
															<b-tr v-for="(
																	itemDimension, idx_itemDimension
																) of option_dimension.itemsDimension" :key="idx_itemDimension">
																<b-td align="center">
																	{{ itemDimension.code }}
																</b-td>
																<b-td>
																	{{ itemDimension.name }}
																</b-td>
																<b-td>
																	{{
																		changeNullIntoStrip(
																			itemDimension.description
																		)
																	}}
																</b-td>
															</b-tr>
														</template>
													</b-tbody>
													<b-tfoot>
														<b-tr>
															<b-td colspan="3" variant="" class="text-right">
																Jumlah Item:
																<template v-if="
																	option_dimension.role.toLowerCase() ===
																	'region'
																">
																	<span class="font-weight-bold">{{
																		optionsRegionUnited.length
																	}}</span>
																</template>

																<template v-if="
																	option_dimension.role.toLowerCase() ===
																	'dimension'
																">
																	<span class="font-weight-bold">{{
																		option_dimension.itemsDimension.length
																	}}</span>
																</template>
															</b-td>
														</b-tr>
													</b-tfoot>
												</b-table-simple>
											</b-col>
										</b-row>
									</div>
								</transition>
							</b-col>
						</b-row>
					</b-card-body>
				</b-collapse>
			</b-card>
		</div>

		<b-row class="mt-3 text-right">
			<b-col>
				<b-button class="mx-1 td-btn-blue" v-show="optionsDimension.length > 0" @click="nextRegularToPeriod()"
					title="Melanjutkan ke opsi periode"><b-icon icon="chevron-double-left" /> Kembali</b-button>

				<b-button class="mx-1 td-btn-blue" v-show="optionsDimension.length > 0"
					:disabled="isDimensionNextEnabled || isLoadingAnOptions" @click="nextToSaveRequest()"
					title="Melanjutkan ke menu keranjang/proses langsung">Lanjut <b-icon
						icon="chevron-double-right" /></b-button>
			</b-col>
		</b-row>
	</div>
</template>

<!-- javascript section-->
<script>
//import js modules section
import services from "../../../../../services/TabelDinamisServicesV3";
import utils from "../../../../../utils/TabelDinamisUtils.js";
import store from "../../../../../store/TabelDinamisStoreV3.js";

const idleStepColor = "lightgray",
	ongoingStepColor = "#f9ad6a",
	finishStepColor = "#56c596";

//local registration for output component
export default {
	name: "DimensionSelection",
	data() {
		return {
			isDimensionNextClicked: false,
			isDimensionSaveClicked: [],
			optionsDimension: "",
			optionsDistrict: "",
			optionsSubdistrict: "",
			optionsProvince: "",
			optionsRegion: "",
			selectedDimension: [],
			selectedDistrict: null,
			selectedProvince: null,
			selectedRegionLevel: "",
			selectedSubdistrict: null,
			allDimensionSelected: [],
			indeterminateDimension: [],
			buttonHeaderColorList: [],
			isDimensionMetadata: [],
			isSelectProvince: false,
			isSelectDistrict: false,
			isSelectSubdistrict: false,
			isSelectRegion: false,
			regionLevel: {
				nas: "nasional",
				prov: "provinsi",
				kako: "kabupaten atau kota",
				kec: "kecamatan",
				deskel: "desa atau kelurahan",
			},
			tempOptionsRegion: "",
		};
	},
	props: [
		"originalOptionsDimension",
		"originalSelectedDimension",
		"originalSelectedDistrict",
		"originalSelectedProvince",
		"originalSelectedRegionLevel",
		"originalSelectedSubdistrict",
		"originalIsDimensionNextClicked",
		"originalIsPeriodNextClicked",
		"datasetName",
		"datasetId",
		"isLoadingAnOptions",
		"isEditSelectedData",
		"idxSelectedData",
		"hasFinishedLoadEditedSelectedData",
	],
	created() { },
	destroyed() { },
	mounted: function () { },
	computed: {
		loadingDimensionInput: function () {
			if (this.optionsDimension === "") {
				return false;
			} else {
				return true;
			}
		},

		loadingProvinceInput: function () {
			if (this.optionsProvince === "") {
				return false;
			} else {
				return true;
			}
		},

		loadingDistrictInput: function () {
			if (this.optionsDistrict === "") {
				return false;
			} else {
				return true;
			}
		},

		loadingSubdistrictInput: function () {
			if (this.optionsSubdistrict === "") {
				return false;
			} else {
				return true;
			}
		},

		loadingRegionInput: function () {
			if (this.optionsRegion === "") {
				return false;
			} else {
				return true;
			}
		},

		isDimensionNextEnabled: function () {
			if (
				this.isDimensionSaveClicked.length > 0 &&
				!this.isDimensionSaveClicked.includes(false)
			) {
				return false;
			} else {
				this.resetDimensionNextClicked();
				return true;
			}
		},

		regionName: function () {
			switch (this.selectedRegionLevel) {
				case "NationalByProvince":
					return "Provinsi :";

				case "ProvinceByDistrict":
					return "Kabupaten/Kota :";

				case "DistrictBySubdistrict":
					return "Kecamatan :";

				case "SubdistrictByVillage":
					return "Desa/Kelurahan :";
				default:
					return "";
			}
		},

		regionDimensionIdx: function () {
			if (this.optionsDimension === "") {
				return null;
			} else {
				return this.optionsDimension.findIndex(
					(item) => item.role.toLowerCase() === "region"
				);
			}
		},

		optionsRegionDimension: function () {
			if (this.regionDimensionIdx == null) {
				return "";
			} else {
				return this.optionsDimension[this.regionDimensionIdx];
			}
		},

		optionsRegionUnited: function () {
			switch (this.selectedRegionLevel) {
				case "":
					return this.optionsRegionDimension["itemsDimension"];

				case "NationalByProvince":
					return this.optionsRegion;

				case "ProvinceByDistrict":
					if (
						this.optionsProvince.length < 1 &&
						this.optionsRegion.length > 0
					) {
						return this.optionsRegion;
					} else if (
						this.optionsProvince.length > 0 &&
						this.optionsRegion.length < 1
					) {
						return this.optionsProvince;
					} else if (
						this.optionsProvince.length > 0 &&
						this.optionsRegion.length > 0
					) {
						return this.optionsProvince.concat(this.optionsRegion.slice(1));
					} else {
						return [];
					}

				case "DistrictBySubdistrict":
					if (
						this.optionsProvince.length < 1 &&
						this.optionsDistrict.length < 1 &&
						this.optionsRegion.length > 0
					) {
						return this.optionsRegion;
					} else if (
						this.optionsProvince.length < 1 &&
						this.optionsDistrict.length > 0 &&
						this.optionsRegion.length < 1
					) {
						return this.optionsDistrict;
					} else if (
						this.optionsProvince.length < 1 &&
						this.optionsDistrict.length > 0 &&
						this.optionsRegion.length > 0
					) {
						return this.optionsDistrict.concat(this.optionsRegion.slice(1));
					} else if (
						this.optionsProvince.length > 0 &&
						this.optionsDistrict.length < 1 &&
						this.optionsRegion.length < 1
					) {
						return this.optionsProvince;
					} else if (
						this.optionsProvince.length > 0 &&
						this.optionsDistrict.length > 0 &&
						this.optionsRegion.length < 1
					) {
						return this.optionsProvince.concat(this.optionsDistrict.slice(1));
					} else if (
						this.optionsProvince.length > 0 &&
						this.optionsDistrict.length > 0 &&
						this.optionsRegion.length > 0
					) {
						return this.optionsProvince
							.concat(this.optionsDistrict.slice(1))
							.concat(this.optionsRegion.slice(1));
					} else {
						return [];
					}

				case "SubdistrictByVillage":
					if (
						this.optionsProvince.length < 1 &&
						this.optionsDistrict.length < 1 &&
						this.optionsSubdistrict.length < 1 &&
						this.optionsRegion.length > 0
					) {
						return this.optionsRegion;
					} else if (
						this.optionsProvince.length < 1 &&
						this.optionsDistrict.length < 1 &&
						this.optionsSubdistrict.length > 0 &&
						this.optionsRegion.length < 1
					) {
						return this.optionsSubdistrict;
					} else if (
						this.optionsProvince.length < 1 &&
						this.optionsDistrict.length < 1 &&
						this.optionsSubdistrict.length > 0 &&
						this.optionsRegion.length > 0
					) {
						return this.optionsSubdistrict.concat(this.optionsRegion.slice(1));
					} else if (
						this.optionsProvince.length < 1 &&
						this.optionsDistrict.length > 0 &&
						this.optionsSubdistrict.length < 1 &&
						this.optionsRegion.length < 1
					) {
						return this.optionsDistrict;
					} else if (
						this.optionsProvince.length < 1 &&
						this.optionsDistrict.length > 0 &&
						this.optionsSubdistrict.length > 0 &&
						this.optionsRegion.length < 1
					) {
						return this.optionsDistrict.concat(
							this.optionsSubdistrict.slice(1)
						);
					} else if (
						this.optionsProvince.length < 1 &&
						this.optionsDistrict.length > 0 &&
						this.optionsSubdistrict.length > 0 &&
						this.optionsRegion.length > 0
					) {
						return this.optionsDistrict
							.concat(this.optionsSubdistrict.slice(1))
							.concat(this.optionsRegion.slice(1));
					} else if (
						this.optionsProvince.length > 0 &&
						this.optionsDistrict.length < 1 &&
						this.optionsSubdistrict.length < 1 &&
						this.optionsRegion.length < 1
					) {
						return this.optionsProvince;
					} else if (
						this.optionsProvince.length > 0 &&
						this.optionsDistrict.length > 0 &&
						this.optionsSubdistrict.length < 1 &&
						this.optionsRegion.length < 1
					) {
						return this.optionsProvince.concat(this.optionsDistrict.slice(1));
					} else if (
						this.optionsProvince.length > 0 &&
						this.optionsDistrict.length > 0 &&
						this.optionsSubdistrict.length > 0 &&
						this.optionsRegion.length < 1
					) {
						return this.optionsProvince
							.concat(this.optionsDistrict.slice(1))
							.concat(this.optionsSubdistrict.slice(1));
					} else if (
						this.optionsProvince.length > 0 &&
						this.optionsDistrict.length > 0 &&
						this.optionsSubdistrict.length > 0 &&
						this.optionsRegion.length > 0
					) {
						return this.optionsProvince
							.concat(this.optionsDistrict.slice(1))
							.concat(this.optionsSubdistrict.slice(1))
							.concat(this.optionsRegion.slice(1));
					} else {
						return [];
					}
				default:
					return null;
			}
		},
	},
	watch: {
		selectedDimension: {
			handler: function (val) {
				if (val != null && val.length > 0) {
					for (let i = 0; i < this.optionsDimension.length; i++) {
						let dimensionRole = this.optionsDimension[i].role.toLowerCase();
						let selectedDimensionLength = this.selectedDimension[i].length;
						let itemsDimensionLength =
							this.optionsDimension[i].itemsDimension.length;
						let optionsRegionLength = this.optionsRegion.length;

						if (
							(dimensionRole !== "region" &&
								selectedDimensionLength === itemsDimensionLength) ||
							(dimensionRole === "region" &&
								optionsRegionLength > 0 &&
								selectedDimensionLength === optionsRegionLength)
						) {
							this.allDimensionSelected[i] = true;
						} else {
							this.allDimensionSelected[i] = false;
						}

						if (
							selectedDimensionLength > 0 &&
							((selectedDimensionLength < itemsDimensionLength &&
								dimensionRole !== "region") ||
								(selectedDimensionLength < optionsRegionLength &&
									dimensionRole === "region"))
						) {
							this.indeterminateDimension[i] = true;
						} else {
							this.indeterminateDimension[i] = false;
						}

						/* if (
							(this.optionsDimension[i].role.toLowerCase() !== "region" &&
								this.selectedDimension[i].length ===
									this.optionsDimension[i].itemsDimension.length) ||
							(this.optionsDimension[i].role.toLowerCase() === "region" &&
								this.optionsRegion.length > 0 &&
								this.selectedDimension[i].length === this.optionsRegion.length)
						) {
							this.allDimensionSelected[i] = true;
						} else {
							this.allDimensionSelected[i] = false;
						}

						if (
							this.selectedDimension[i].length > 0 &&
							((this.selectedDimension[i].length <
								this.optionsDimension[i].itemsDimension.length &&
								this.optionsDimension[i].role.toLowerCase() !== "region") ||
								(this.selectedDimension[i].length < this.optionsRegion.length &&
									this.optionsDimension[i].role.toLowerCase() === "region"))
						) {
							this.indeterminateDimension[i] = true;
						} else {
							this.indeterminateDimension[i] = false;
						} */

						this.$set(
							this.buttonHeaderColorList,
							i,
							this.setButtonHeaderColorList(i)
						);
					}
				}

				this.$emit("update:originalSelectedDimension", val);
			},
			deep: true,
			immediate: true,
		},

		selectedDistrict: {
			handler: function (val) {
				this.$emit("update:originalSelectedDistrict", val);
			},
			deep: true,
		},

		selectedProvince: {
			handler: function (val) {
				this.$emit("update:originalSelectedProvince", val);
			},
			deep: true,
		},

		selectedSubdistrict: {
			handler: function (val) {
				this.$emit("update:originalSelectedSubdistrict", val);
			},
			deep: true,
		},

		selectedRegionLevel: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.resetDataVarRegionDimension();

					switch (newVal) {
						case "NationalByProvince":
							this.isSelectRegion = true;
							this.assignOptionsRegionWithInitialOptionRegion();
							break;

						case "ProvinceByDistrict":
							if (
								this.optionsRegionDimension.initialParentLevel.toLowerCase() ===
								this.regionLevel.nas
							) {
								this.isSelectProvince = true;

								setTimeout(
									function () {
										this.optionsProvince =
											this.optionsRegionDimension.itemsDimension;

										if (
											this.isEditSelectedData &&
											!this.hasFinishedLoadEditedSelectedData
										) {
											this.setSelectedProvinceFromSelectedDataListLocalStorage();
										}
									}.bind(this),
									100
								);
							} else if (
								this.optionsRegionDimension.initialParentLevel.toLowerCase() ===
								this.regionLevel.prov
							) {
								this.isSelectRegion = true;
								this.assignOptionsRegionWithInitialOptionRegion();
							}
							break;

						case "DistrictBySubdistrict":
							if (
								this.optionsRegionDimension.initialParentLevel.toLowerCase() ===
								this.regionLevel.nas
							) {
								this.isSelectProvince = true;

								setTimeout(
									function () {
										this.optionsProvince =
											this.optionsRegionDimension.itemsDimension;

										if (
											this.isEditSelectedData &&
											!this.hasFinishedLoadEditedSelectedData
										) {
											this.setSelectedProvinceFromSelectedDataListLocalStorage();
										}
									}.bind(this),
									100
								);
							} else if (
								this.optionsRegionDimension.initialParentLevel.toLowerCase() ===
								this.regionLevel.prov
							) {
								this.isSelectDistrict = true;

								setTimeout(
									function () {
										this.optionsDistrict =
											this.optionsRegionDimension.itemsDimension;

										if (
											this.isEditSelectedData &&
											!this.hasFinishedLoadEditedSelectedData
										) {
											this.setSelectedDistrictFromSelectedDataListLocalStorage();
										}
									}.bind(this),
									100
								);
							} else if (
								this.optionsRegionDimension.initialParentLevel.toLowerCase() ===
								this.regionLevel.kako
							) {
								this.isSelectRegion = true;
								this.assignOptionsRegionWithInitialOptionRegion();
							}
							break;

						case "SubdistrictByVillage":
							if (
								this.optionsRegionDimension.initialParentLevel.toLowerCase() ===
								this.regionLevel.nas
							) {
								this.isSelectProvince = true;

								setTimeout(
									function () {
										this.optionsProvince =
											this.optionsRegionDimension.itemsDimension;

										if (
											this.isEditSelectedData &&
											!this.hasFinishedLoadEditedSelectedData
										) {
											this.setSelectedProvinceFromSelectedDataListLocalStorage();
										}
									}.bind(this),
									100
								);
							} else if (
								this.optionsRegionDimension.initialParentLevel.toLowerCase() ===
								this.regionLevel.prov
							) {
								this.isSelectDistrict = true;

								setTimeout(
									function () {
										this.optionsDistrict =
											this.optionsRegionDimension.itemsDimension;

										if (
											this.isEditSelectedData &&
											!this.hasFinishedLoadEditedSelectedData
										) {
											this.setSelectedDistrictFromSelectedDataListLocalStorage();
										}
									}.bind(this),
									100
								);
							} else if (
								this.optionsRegionDimension.initialParentLevel.toLowerCase() ===
								this.regionLevel.kako
							) {
								this.isSelectSubdistrict = true;

								setTimeout(
									function () {
										this.optionsSubdistrict =
											this.optionsRegionDimension.itemsDimension;

										if (
											this.isEditSelectedData &&
											!this.hasFinishedLoadEditedSelectedData
										) {
											this.setSelectedSubdistrictFromSelectedDataListLocalStorage();
										}
									}.bind(this),
									100
								);
							} else if (
								this.optionsRegionDimension.initialParentLevel.toLowerCase() ===
								this.regionLevel.deskel
							) {
								this.isSelectRegion = true;
								this.assignOptionsRegionWithInitialOptionRegion();
							}
							break;
					}

					this.$emit("update:originalSelectedRegionLevel", newVal);
				}
			},
		},

		isDimensionSaveClicked: {
			handler: function () {
				for (let i = 0; i < this.optionsDimension.length; i++) {
					this.$set(
						this.buttonHeaderColorList,
						i,
						this.setButtonHeaderColorList(i)
					);
				}
			},
			deep: true,
			immediate: true,
		},

		optionsDimension: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.$emit("update:originalOptionsDimension", this.optionsDimension);
				}
			},
			deep: true,
			immediate: true,
		},

		originalIsPeriodNextClicked: function (val) {
			this.optionsDimension = "";
			this.optionsProvince = "";
			this.optionsDistrict = "";
			this.optionsSubdistrict = "";
			this.optionsRegion = "";
			this.selectedRegionLevel = "";

			this.selectedDimension = [];
			this.allDimensionSelected = [];
			this.indeterminateDimension = [];
			this.isDimensionSaveClicked = [];
			this.isDimensionNextClicked = false;

			if (val) {
				this.$emit("update:isLoadingAnOptions", true);

				let statusDimensionOptionsLocalStorage =
					store.precheckDimensionOptionsLocalStorage(this.datasetId);

				switch (statusDimensionOptionsLocalStorage) {
					case "expired":
					case "not-set":
						this.loadDimensionByDataset(this.datasetId);
						break;
					case "alive":
						setTimeout(
							function () {
								this.optionsDimension = JSON.parse(
									store.getSelectionLocalStorageByKey("dimension")
								).find((item) => item.datasetId === this.datasetId).items;

								this.initializeDimensionDataVar();

								if (
									this.isEditSelectedData &&
									!this.hasFinishedLoadEditedSelectedData
								) {
									let selectedDimension =
										this.getSelectedDimensionFromSelectedDataListLocalStorage();

									selectedDimension.forEach((item, idx) => {
										if (item.role.toLowerCase() === "region") {
											this.selectedRegionLevel = item.selectedRegionLevel;
										}

										this.$set(
											this.selectedDimension,
											idx,
											item.selectedItemDimension
										);

										this.$set(this.isDimensionSaveClicked, idx, true);
									});
								}
							}.bind(this),
							200
						);

						this.$emit("update:isLoadingAnOptions", false);
						break;
				}
			}
		},

		isDimensionNextClicked: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.$emit(
						"update:originalIsDimensionNextClicked",
						this.isDimensionNextClicked
					);
				}
			},
			immediate: true,
		},

		originalSelectedDimension: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.selectedDimension = newVal;
				}
			},
			immediate: true,
		},

		originalOptionsDimension: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.optionsDimension = newVal;
				}
			},
		},

		originalSelectedProvince: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.selectedProvince = newVal;
				}
			},
		},

		originalSelectedDistrict: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.selectedDistrict = newVal;
				}
			},
		},

		originalSelectedSubdistrict: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.selectedSubdistrict = newVal;
				}
			},
		},

		originalSelectedRegionLevel: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.selectedRegionLevel = newVal;
				}
			},
		},
	},
	methods: {
		async loadDimensionByDataset(val) {
			await services.getDimensionByDatasetId(val).then(
				(response) => {
					this.optionsDimension = response.data.data.dimensionList;
					utils.sortArrayByNumberProperty(this.optionsDimension, "columnOrder");
					this.initializeDimensionDataVar();

					store.updateSelectionLocalStorage(
						"dimension",
						this.optionsDimension,
						{
							datasetName: this.datasetName,
							datasetId: this.datasetId,
						}
					);

					if (
						this.isEditSelectedData &&
						!this.hasFinishedLoadEditedSelectedData
					) {
						let selectedDimension =
							this.getSelectedDimensionFromSelectedDataListLocalStorage();

						selectedDimension.forEach((item, idx) => {
							if (item.role.toLowerCase() === "region") {
								this.selectedRegionLevel = item.selectedRegionLevel;
							}

							this.$set(
								this.selectedDimension,
								idx,
								item.selectedItemDimension
							);

							this.$set(this.isDimensionSaveClicked, idx, true);
						});
					}

					this.$emit("update:isLoadingAnOptions", false);
				},
				(error) => {
					this.data =
						(error.response && error.response.data) ||
						error.message ||
						error.toString();

					this.$emit("update:isLoadingAnOptions", false);
				}
			);
		},

		async loadRegionChildrenItem(parentRegion, target) {
			await services
				.getChildrenRegionByDatasetIdDimensionIdParentRegionId(
					this.datasetId,
					this.optionsRegionDimension.id,
					parentRegion.id
				)
				.then(
					(response) => {
						this[target] = response.data.data.itemRegionList.itemsDimension;

						store.updateSelectionLocalStorage("regionChild", this[target], {
							datasetName: this.datasetName,
							datasetId: this.datasetId,
							dimensionName: this.optionsRegionDimension.name,
							dimensionId: this.optionsRegionDimension.id,
							parentRegionId: parentRegion.id,
							parentRegionName: parentRegion.name,
						});

						if (
							this.isEditSelectedData &&
							!this.hasFinishedLoadEditedSelectedData
						) {
							switch (target) {
								case "optionsRegion":
									this.setSelectedDimensionRegionFromSelectedDataListLocalStorage();

									this.isDimensionNextClicked = true;

									this.$emit("update:hasFinishedLoadEditedSelectedData", true);

									break;

								case "optionsDistrict":
									this.setSelectedDistrictFromSelectedDataListLocalStorage();
									break;

								case "optionsSubdistrict":
									this.setSelectedSubdistrictFromSelectedDataListLocalStorage();
									break;
							}
						}

						this.$emit("update:isLoadingAnOptions", false);
					},
					(error) => {
						this.data =
							(error.response && error.response.data) ||
							error.message ||
							error.toString();
						this.$emit("update:isLoadingAnOptions", false);
					}
				);
		},

		initializeDimensionDataVar() {
			this.selectedDimension = [];
			this.allDimensionSelected = [];
			this.indeterminateDimension = [];
			this.isDimensionSaveClicked = [];
			this.buttonHeaderColorList = [];
			this.isDimensionMetadata = [];
			this.selectedRegionLevel = "";

			for (let i = 0; i < this.optionsDimension.length; i++) {
				this.selectedDimension[i] = [];
				this.allDimensionSelected[i] = false;
				this.indeterminateDimension[i] = false;
				this.isDimensionSaveClicked[i] = false;
				this.buttonHeaderColorList[i] = ongoingStepColor;
				this.isDimensionMetadata[i] = false;
			}
		},

		resetDataVarRegionDimension() {
			this.optionsDistrict = "";
			this.optionsSubdistrict = "";
			this.optionsProvince = "";
			this.optionsRegion = "";
			this.selectedDistrict = null;
			this.selectedSubdistrict = null;
			this.selectedProvince = null;
			this.isSelectProvince = false;
			this.isSelectDistrict = false;
			this.isSelectSubdistrict = false;
			this.isSelectRegion = false;

			this.selectedDimension[this.regionDimensionIdx] = [];
			this.allDimensionSelected[this.regionDimensionIdx] = false;
			this.indeterminateDimension[this.regionDimensionIdx] = false;
			this.setIsDimensionSaveClicked(this.regionDimensionIdx, false);
		},

		setButtonHeaderColorList(idx_dimension) {
			if (this.optionsDimension[idx_dimension] === []) {
				return idleStepColor;
			} else if (
				this.optionsDimension[idx_dimension].itemsDimension !== [] &&
				!this.isDimensionSaveClicked[idx_dimension]
			) {
				return ongoingStepColor;
			} else if (
				this.optionsDimension[idx_dimension].itemsDimension !== [] &&
				this.selectedDimension[idx_dimension] != [] &&
				this.isDimensionSaveClicked[idx_dimension]
			) {
				return finishStepColor;
			}
		},

		setIsDimensionSaveClicked(idx_dimension, boolean) {
			this.$set(this.isDimensionSaveClicked, idx_dimension, boolean);

			if (boolean) {
				setTimeout(
					function () {
						this.collapseDimensionAccordion(idx_dimension);
						this.rotateAccordionIconButtonHeader(null, idx_dimension);
					}.bind(this),
					500
				);
			}
		},

		toggleAllDimension(val, idx_dimension) {
			this.setIsDimensionSaveClicked(idx_dimension, false);
			this.$set(this.selectedDimension, idx_dimension, []);

			if (val) {
				if (
					this.optionsDimension[idx_dimension].role.toLowerCase() !== "region"
				) {
					this.$set(
						this.selectedDimension,
						idx_dimension,
						this.optionsDimension[idx_dimension].itemsDimension
					);
				} else if (
					this.optionsDimension[idx_dimension].role.toLowerCase() === "region"
				) {
					this.$set(this.selectedDimension, idx_dimension, this.optionsRegion);
				}
			}
		},

		nextToSaveRequest() {
			if (
				this.isDimensionSaveClicked.length > 0 &&
				!this.isDimensionSaveClicked.includes(false)
			) {
				this.isDimensionNextClicked = true;
				// utils.scrollIntoDiv(
				// 	"tabel-dinamis-progress-stepper-period"
				// );
			}
		},

		nextRegularToPeriod() {
			utils.scrollIntoDiv("tabel-dinamis-progress-stepper-period");
		},

		nextFromProvince() {
			switch (this.selectedRegionLevel) {
				case "ProvinceByDistrict":
					if (this.optionsRegion === "") {
						this.isSelectRegion = true;
						this.$emit("update:isLoadingAnOptions", true);

						let statusRegionChildOptionsLocalStorage =
							store.precheckRegionChildOptionsLocalStorage(
								this.datasetId,
								this.optionsRegionDimension.id,
								this.selectedProvince.id
							);

						switch (statusRegionChildOptionsLocalStorage) {
							case "expired":
							case "not-set":
								this.loadRegionChildrenItem(
									this.selectedProvince,
									"optionsRegion"
								);
								break;

							case "alive":
								setTimeout(
									function () {
										this.optionsRegion = JSON.parse(
											store.getSelectionLocalStorageByKey("regionChild")
										).find(
											(item) =>
												item.datasetId === this.datasetId &&
												item.dimensionId === this.optionsRegionDimension.id &&
												item.parentRegionId === this.selectedProvince.id
										).items;

										if (
											this.isEditSelectedData &&
											!this.hasFinishedLoadEditedSelectedData
										) {
											let selectedDimension =
												this.getSelectedDimensionFromSelectedDataListLocalStorage();

											for (
												let index = 0;
												index < selectedDimension.length;
												index++
											) {
												if (
													selectedDimension[index].role.toLowerCase() ===
													"region"
												) {
													this.$set(
														this.selectedDimension,
														index,
														selectedDimension[index].selectedItemDimension
													);

													this.$set(this.isDimensionSaveClicked, index, true);

													break;
												}
											}

											this.isDimensionNextClicked = true;

											this.$emit(
												"update:hasFinishedLoadEditedSelectedData",
												true
											);
										}

										this.$emit("update:isLoadingAnOptions", false);
									}.bind(this),
									200
								);

								break;
						}
					}

					break;
				case "DistrictBySubdistrict":
				case "SubdistrictByVillage":
					if (this.optionsRegion === "") {
						this.isSelectDistrict = true;
						this.$emit("update:isLoadingAnOptions", true);

						let statusRegionChildOptionsLocalStorage =
							store.precheckRegionChildOptionsLocalStorage(
								this.datasetId,
								this.optionsRegionDimension.id,
								this.selectedProvince.id
							);

						switch (statusRegionChildOptionsLocalStorage) {
							case "expired":
							case "not-set":
								this.loadRegionChildrenItem(
									this.selectedProvince,
									"optionsDistrict"
								);
								break;

							case "alive":
								setTimeout(
									function () {
										this.optionsDistrict = JSON.parse(
											store.getSelectionLocalStorageByKey("regionChild")
										).find(
											(item) =>
												item.datasetId === this.datasetId &&
												item.dimensionId === this.optionsRegionDimension.id &&
												item.parentRegionId === this.selectedProvince.id
										).items;

										if (
											this.isEditSelectedData &&
											!this.hasFinishedLoadEditedSelectedData
										) {
											this.setSelectedDistrictFromSelectedDataListLocalStorage();
										}
									}.bind(this),
									200
								);

								this.$emit("update:isLoadingAnOptions", false);
								break;
						}
					}

					break;
			}
		},

		nextFromDistrict() {
			switch (this.selectedRegionLevel) {
				case "DistrictBySubdistrict":
					if (this.optionsRegion === "") {
						this.isSelectRegion = true;
						this.$emit("update:isLoadingAnOptions", true);

						let statusRegionChildOptionsLocalStorage =
							store.precheckRegionChildOptionsLocalStorage(
								this.datasetId,
								this.optionsRegionDimension.id,
								this.selectedDistrict.id
							);

						switch (statusRegionChildOptionsLocalStorage) {
							case "expired":
							case "not-set":
								this.loadRegionChildrenItem(
									this.selectedDistrict,
									"optionsRegion"
								);
								break;

							case "alive":
								setTimeout(
									function () {
										this.optionsRegion = JSON.parse(
											store.getSelectionLocalStorageByKey("regionChild")
										).find(
											(item) =>
												item.datasetId === this.datasetId &&
												item.dimensionId === this.optionsRegionDimension.id &&
												item.parentRegionId === this.selectedDistrict.id
										).items;

										if (
											this.isEditSelectedData &&
											!this.hasFinishedLoadEditedSelectedData
										) {
											let selectedDimension =
												this.getSelectedDimensionFromSelectedDataListLocalStorage();

											for (
												let index = 0;
												index < selectedDimension.length;
												index++
											) {
												if (
													selectedDimension[index].role.toLowerCase() ===
													"region"
												) {
													this.$set(
														this.selectedDimension,
														index,
														selectedDimension[index].selectedItemDimension
													);

													this.$set(this.isDimensionSaveClicked, index, true);

													break;
												}
											}

											this.isDimensionNextClicked = true;
											this.$emit(
												"update:hasFinishedLoadEditedSelectedData",
												true
											);
										}
									}.bind(this),
									200
								);

								this.$emit("update:isLoadingAnOptions", false);
								break;
						}
					}

					break;

				case "SubdistrictByVillage":
					if (this.optionsRegion === "") {
						this.isSelectSubdistrict = true;
						this.$emit("update:isLoadingAnOptions", true);

						let statusRegionChildOptionsLocalStorage =
							store.precheckRegionChildOptionsLocalStorage(
								this.datasetId,
								this.optionsRegionDimension.id,
								this.selectedDistrict.id
							);

						switch (statusRegionChildOptionsLocalStorage) {
							case "expired":
							case "not-set":
								this.loadRegionChildrenItem(
									this.selectedDistrict,
									"optionsSubdistrict"
								);
								break;

							case "alive":
								setTimeout(
									function () {
										this.optionsSubdistrict = JSON.parse(
											store.getSelectionLocalStorageByKey("regionChild")
										).find(
											(item) =>
												item.datasetId === this.datasetId &&
												item.dimensionId === this.optionsRegionDimension.id &&
												item.parentRegionId === this.selectedDistrict.id
										).items;

										if (
											this.isEditSelectedData &&
											!this.hasFinishedLoadEditedSelectedData
										) {
											this.setSelectedSubdistrictFromSelectedDataListLocalStorage();
										}
									}.bind(this),
									200
								);

								this.$emit("update:isLoadingAnOptions", false);
								break;
						}
					}
					break;
			}
		},

		nextFromSubdistrict() {
			switch (this.selectedRegionLevel) {
				case "SubdistrictByVillage":
					if (this.optionsRegion === "") {
						this.isSelectRegion = true;
						this.$emit("update:isLoadingAnOptions", true);

						let statusRegionChildOptionsLocalStorage =
							store.precheckRegionChildOptionsLocalStorage(
								this.datasetId,
								this.optionsRegionDimension.id,
								this.selectedSubdistrict.id
							);

						switch (statusRegionChildOptionsLocalStorage) {
							case "expired":
							case "not-set":
								this.loadRegionChildrenItem(
									this.selectedSubdistrict,
									"optionsRegion"
								);
								break;

							case "alive":
								setTimeout(
									function () {
										this.optionsRegion = JSON.parse(
											store.getSelectionLocalStorageByKey("regionChild")
										).find(
											(item) =>
												item.datasetId === this.datasetId &&
												item.dimensionId === this.optionsRegionDimension.id &&
												item.parentRegionId === this.selectedSubdistrict.id
										).items;

										if (
											this.isEditSelectedData &&
											!this.hasFinishedLoadEditedSelectedData
										) {
											let selectedDimension =
												this.getSelectedDimensionFromSelectedDataListLocalStorage();

											for (
												let index = 0;
												index < selectedDimension.length;
												index++
											) {
												if (
													selectedDimension[index].role.toLowerCase() ===
													"region"
												) {
													this.$set(
														this.selectedDimension,
														index,
														selectedDimension[index].selectedItemDimension
													);

													this.$set(this.isDimensionSaveClicked, index, true);

													break;
												}
											}

											this.isDimensionNextClicked = true;
											this.$emit(
												"update:hasFinishedLoadEditedSelectedData",
												true
											);
										}
									}.bind(this),
									200
								);

								this.$emit("update:isLoadingAnOptions", false);
								break;
						}
					}
					break;
			}
		},

		capitalizeEachWord(str) {
			return utils.capitalizeEachWord(str);
		},
		rotateAccordionIconButtonHeader(event, idx_dimension) {
			document
				.getElementById(
					"accordion-dimension-icon-button-header-" + idx_dimension
				)
				.classList.toggle("tabel-dinamis-rotateHalf");
		},
		collapseDimensionAccordion(idx_dimension) {
			this.$root.$emit(
				"bv::toggle::collapse",
				"tabel-dinamis-dimension-accordion-" + idx_dimension
			);
		},
		changeNullIntoStrip(val) {
			return utils.changeNullIntoStrip(val);
		},
		reverseIsDimensionMetadata(idx_dimension) {
			this.$set(
				this.isDimensionMetadata,
				idx_dimension,
				!this.isDimensionMetadata[idx_dimension]
			);
		},
		assignOptionsRegionWithInitialOptionRegion() {
			setTimeout(
				function () {
					this.optionsRegion = this.optionsRegionDimension.itemsDimension;

					if (
						this.isEditSelectedData &&
						!this.hasFinishedLoadEditedSelectedData
					) {
						this.setSelectedDimensionRegionFromSelectedDataListLocalStorage();

						this.isDimensionNextClicked = true;
						this.$emit("update:hasFinishedLoadEditedSelectedData", true);
					}
				}.bind(this),
				200
			);
		},

		getSelectedDataListFromSelectedDataListLocalStorage() {
			return store.getSelectedDataListLocalStorageByCurrentUsername();
		},

		getSelectedDimensionFromSelectedDataListLocalStorage() {
			let selectedDataList =
				this.getSelectedDataListFromSelectedDataListLocalStorage();

			return selectedDataList[0].items[this.idxSelectedData].selectedDimension;
		},

		setSelectedDimensionRegionFromSelectedDataListLocalStorage() {
			let selectedDimension =
				this.getSelectedDimensionFromSelectedDataListLocalStorage();

			let idxFoundRegion = selectedDimension.findIndex((item) => {
				return item.role.toLowerCase() === "region";
			});

			this.$set(
				this.selectedDimension,
				idxFoundRegion,
				selectedDimension[idxFoundRegion].selectedItemDimension
			);

			this.$set(this.isDimensionSaveClicked, idxFoundRegion, true);
		},

		setSelectedProvinceFromSelectedDataListLocalStorage() {
			let selectedDimension =
				this.getSelectedDimensionFromSelectedDataListLocalStorage();

			for (let index = 0; index < selectedDimension.length; index++) {
				if (selectedDimension[index].role.toLowerCase() === "region") {
					this.selectedProvince = selectedDimension[index].selectedProvince;

					this.nextFromProvince();

					break;
				}
			}
		},

		setSelectedDistrictFromSelectedDataListLocalStorage() {
			let selectedDimension =
				this.getSelectedDimensionFromSelectedDataListLocalStorage();

			for (let index = 0; index < selectedDimension.length; index++) {
				if (selectedDimension[index].role.toLowerCase() === "region") {
					this.selectedDistrict = selectedDimension[index].selectedDistrict;

					this.nextFromDistrict();

					break;
				}
			}
		},

		setSelectedSubdistrictFromSelectedDataListLocalStorage() {
			let selectedDimension =
				this.getSelectedDimensionFromSelectedDataListLocalStorage();

			for (let index = 0; index < selectedDimension.length; index++) {
				if (selectedDimension[index].role.toLowerCase() === "region") {
					this.selectedSubdistrict =
						selectedDimension[index].selectedSubdistrict;

					this.nextFromSubdistrict();

					break;
				}
			}
		},

		resetDimensionNextClicked() {
			this.isDimensionNextClicked = false;
		},
	},
	components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";

.tabel-dinamis-select-region-level {
	width: 50% !important;
}
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 25-04-2022 -->